import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const vertexAISlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getVertexAIFeedback: builder.mutation({
            query: (arg: any) => ({
                url: constants.GET_VERTEX_AI_FEEDBACK,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
        }),
        getAIGameplanSummary: builder.mutation({
            query: (arg: any) => ({
                url: constants.GET_AI_GAMEPLAN_SUMMARY,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
        }),

        getAIExtractRecordingInsights: builder.mutation({
            query: (arg: any) => ({
                url: constants.GET_EXTRACT_RECORDING_INSIGHTS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
        }),
        getAIRecordingCAP: builder.mutation({
            query: (arg: any) => ({
                url: constants.GET_RECORDING_CAP,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
        }),
    }),
});


export const { useGetVertexAIFeedbackMutation, useGetAIGameplanSummaryMutation, useGetAIExtractRecordingInsightsMutation,
useGetAIRecordingCAPMutation
 } = vertexAISlice;
